import BottomSheet from "@/shared/ui/BottomSheet";
import PrimaryButton from "@/shared/ui/PrimaryButton";
import { cautionIcon } from "@/shared/ui/alertDialogIcons";
import { useTapInteraction } from "@/shared/ui/pressable";
import styles from "./Credit4uDesyncCsSheet.module.scss";

export type Credit4uDesyncCsSheetProps = {
  isOpen: boolean;
  /** [문의하기] — 고객센터(CS) 문의 채널 연결 */
  onContactCs: () => void;
  /** [닫기] — 팝업만 닫고 비밀번호 미갱신 상태 유지 */
  onClose: () => void;
};

type SecondaryButtonProps = {
  onClick: () => void;
  children: string;
};

const SecondaryButton = ({ onClick, children }: SecondaryButtonProps) => {
  const { isPressed, ref, pressHandlers } =
    useTapInteraction<HTMLButtonElement>();
  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.ctaSecondary} ${isPressed ? styles.pressed : ""}`.trim()}
      onClick={onClick}
      {...pressHandlers}
    >
      {children}
    </button>
  );
};

// 비밀번호 변경 오류(DESYNC) CS 문의 팝업 — Figma 4506:13300 / 4506:13301.
// 비밀번호 변경 완료 중 서버 저장 오류(CODEF엔 새 비번 반영 / DB 미반영)로 정상 완료되지 못한 경우 노출.
// 공통 floating BottomSheet(Dim Fade In + 하단→상단 slide up). 배경 Dim 탭 / native back 닫힘 불가(흔들림) —
// [문의하기]/[닫기] 버튼으로만 처리 (Credit4uPasswordExpirySheet 와 동일 잠금 config).
const Credit4uDesyncCsSheet = ({
  isOpen,
  onContactCs,
  onClose,
}: Credit4uDesyncCsSheetProps) => (
  <BottomSheet
    isOpen={isOpen}
    // 외부 닫힘 트리거가 onClose 를 부르지 않는다(backdrop·native back 은 흔들림, ESC 비활성) — no-op.
    onClose={() => {}}
    presentation="partial"
    placementStyle="floating"
    showCloseButton={false}
    closeOnBackdrop={false}
    closeOnEsc={false}
    draggable={false}
    showDragHandle={false}
    backdropOpacity={0.6}
    contentClassName={styles.sheetContent}
  >
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="credit4u-desync-cs-title"
      className={styles.sheetBody}
    >
      <img
        src={cautionIcon}
        alt=""
        className={styles.icon}
        width="50"
        height="50"
      />
      <div className={styles.textGroup}>
        <h2 id="credit4u-desync-cs-title" className={styles.title}>
          오류가 발생했어요
        </h2>
        <p className={styles.desc}>
          {"일시적인 문제로 변경을 완료하지 못했어요.\n고객센터로 문의해 주세요."}
        </p>
      </div>
    </div>
    <div className={styles.actions}>
      <PrimaryButton type="button" onClick={onContactCs}>
        문의하기
      </PrimaryButton>
      <SecondaryButton onClick={onClose}>닫기</SecondaryButton>
    </div>
  </BottomSheet>
);

export default Credit4uDesyncCsSheet;
